<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ creditor.creditor_name }}
            <br />
            {{ creditor.address_line }}
            <br />
            {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
        </p>
        <p>
            VIA USPS CERTIFIED MAIL/RETURN RECEIPT # [tracking number here]
        </p>
        <p class="letter-content">
            <b>
                Re:	Follow up dispute of alleged deficiency balance; Account #: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
            </b>
        </p>
        <p>
            Dear {{ creditor.creditor_name }}:
        </p>
        <p class="letter-content">
            The purpose of this letter is to follow up on my letter to you dated {{ originalCreditedDate != null ? moment(originalCreditedDate).format('LL'):'[date of 1st letter]' }}. You continue to credit report and attempt to collect an alleged 
            <template v-if="lodash.isEmpty(creditor.balance)">
                $[<span style="background-color: #fbff1d;">$[amount]</span>]
            </template>
            <template v-else>
                ${{ creditor.balance }}
            </template>
            deficiency. You have failed to timely comply with the demands in my first letter to you. Specifically, you have failed to provide me with the following documents and proof:
        </p>
        <ol>
            <li>
                Verification of the alleged debt, including
                <ol type="a">
                    <li class="letter-content">
                        the name and address of the original creditor, and 
                    </li>
                    <li class="letter-content">
                        a copy of any signed contract or agreement with the original creditor;
                    </li>
                </ol>
            </li>
            <li class="letter-content">
                A copy of the legally required notice before disposition of collateral;
            </li>
            <li class="letter-content">
                A copy of the explanation of deficiency following disposition of collateral;
            </li>
            <li class="letter-content">
                Proof that you have ceased collection and credit reporting of the deficiency.
            </li>
        </ol>
        <p class="letter-content">
            I request that you immediately write to confirm your compliance with my demand. This letter is as a complaint to the Consumer Financial Protection Bureau (CFPB). The CFPB is authorized to investigate this issue and receive any related information. If you fail to comply with this letter, I may turn the matter over to an attorney or sue.
        </p>
        <p style="page-break-after: always;">
            Sincerely,
            <br />
            <br/>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            SSN: {{ userStore.user.ssn }}
            <br />
            DOB: {{ userStore.user.dob }}
            <br />
            cc:	Consumer Financial Protection Bureau via fax 1-855-237-2392
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../../../stores/UserStore.js'
    import { useReportStore } from '../../../../stores/ReportStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            },
            originalCreditedDate:{
                type: String
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                lodash: lodash,
                moment:moment
            };
        }
    };
</script>